module.exports = __webpack_public_path__ + "static/icons/icon-insurance-b710f59c54387036de3cab37cef069ba.svg";